
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { DashboardTab } from './DashboardTab';
import { DataType } from '@/core/data/DataType';

import StatEntrances from '../stats/StatEntrances.vue';
import ChartEntrancePie from '../charts/ChartEntrancePie.vue';
import TableEntrancePopularity from '../tables/TableEntrancePopularity.vue';
import { EnterExitDailyRecord } from '@/core/data/sets/EnterExitDailyRecord';
import { FView } from '@/core/FView';

@DashboardTab("Распределение по входам", '<i class="fas fa-chart-pie"></i>', 'entrance-distribution', [DataType.EnterExitDaily, DataType.EnterExitHourly])
@Component ({
  components: {
    StatEntrances,
    ChartEntrancePie,
    TableEntrancePopularity,
  }
})
export default class extends Vue {
    getUnuniqueDataSet() {
        return FView.Get().dataManager.GetShownRecords<EnterExitDailyRecord>(DataType.EnterExitHourly);
    }
}

